export const SEARCH_REGIONS_LIMIT = 30;
